export default __webpack_public_path__ + "static/media/PotentiometersImg.76d81e87.jpg";